import axios from 'axios';

const resetDirectKeyLoginCounter = async (body: {
  userId: string;
  orgId: string;
}) => {
  await axios.post('/supra_system/subscription/reset_login_counter', body);
};

export default resetDirectKeyLoginCounter;
